import axios from 'axios';

const CheckoutProvider = axios.create({
    baseURL: process.env.BASE_URL
        ? process.env.BASE_URL
        : '/'
});

export default CheckoutProvider;
